import React from 'react';
import { api } from '../../../fetch/bussiness/api';
import { CLSTAG } from '../../../utils/constant';
import { clstagStr } from '../../../utils/util';
import { TakeOverStatus } from '@/views/PatrolMode/types';
interface Props {
  isStoped: boolean;
  disabled: boolean;
  operatorIsSelf: boolean;
  takeOverStatus: string;
  operateRequest: (name: string) => void;
  onShowMessage: (name: string) => void;
}
const StopOrRecovery = (props: Props) => {
  const { isStoped, disabled, operatorIsSelf, takeOverStatus } = props;
  const onClickStopBtn = () => {
    if (disabled) {
      return;
    }
    props.operateRequest(api.emergencyStop);
  };

  const onClickRecoveryBtn = () => {
    if (disabled) {
      return;
    }
    props.onShowMessage('takeover');
  };

  return (
    <>
      {!isStoped ? (
        <>
          <li
            className={disabled ? 'item stop-no-operate' : 'item stop'}
            onClick={onClickStopBtn}
            clstag={clstagStr(CLSTAG.StopBtnClick)}
          >
            <h3 className='tit stop-title'>{'急 停'}</h3>
          </li>
        </>
      ) : (
        <>
          {operatorIsSelf && takeOverStatus === TakeOverStatus.TAKEOVER ? (
            <li
              className={
                disabled ? 'item stop-no-operate ' : 'item stop-active'
              }
              onClick={onClickRecoveryBtn}
              clstag={clstagStr(CLSTAG.RecoverBtnClick)}
            >
              <h3 className='tit stop-title'>恢 复</h3>
            </li>
          ) : operatorIsSelf && takeOverStatus === TakeOverStatus.TEMPORARY ? (
            <>
              <li
                className={disabled ? 'item stop-no-operate' : 'item stop'}
                onClick={onClickStopBtn}
                clstag={clstagStr(CLSTAG.StopBtnClick)}
              >
                <h3 className='tit stop-title'>{'急 停'}</h3>
              </li>
            </>
          ) : (
            <li className={'item stop-no-operate'}>
              <h3 className='tit stop-title'>恢 复</h3>
            </li>
          )}
        </>
      )}
    </>
  );
};
export default StopOrRecovery;
